import { render, staticRenderFns } from "./labelManage.vue?vue&type=template&id=3dd4c63e&scoped=true&"
import script from "./labelManage.vue?vue&type=script&lang=js&"
export * from "./labelManage.vue?vue&type=script&lang=js&"
import style0 from "./labelManage.vue?vue&type=style&index=0&id=3dd4c63e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd4c63e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dd4c63e')) {
      api.createRecord('3dd4c63e', component.options)
    } else {
      api.reload('3dd4c63e', component.options)
    }
    module.hot.accept("./labelManage.vue?vue&type=template&id=3dd4c63e&scoped=true&", function () {
      api.rerender('3dd4c63e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/client/labelManage/labelManage.vue"
export default component.exports